<template>
  <div class="md-layout md-alignment-center-right" style="width: 100%">
    <template v-if="hasNoPhysicalEntries && !hasAllPhysicalEntries">
      <md-switch
        v-if="!isTransfer"
        v-model="value.parcialInputsMode"
        :disabled="
          loading ||
          !$can('can_change_material_input', 'IWarehouse', 'iwarehousemovement')
        "
      >
        {{
        value.parcialInputsMode ? "Cambiar a entrada completa" : "Cambiar a entradas parciales"
        }}
      </md-switch>
      <md-button
        class="md-round md-dense"
        @click="sendData"
        :disabled="
          loading ||
          !$can(
            'can_change_material_input',
            'IWarehouse',
            'iwarehousemovement'
          ) ||
          (value.parcialInputsMode && !isValid)
        "
        :class="!value.parcialInputsMode ? 'md-success' : 'md-primary'"
      >
        <md-progress-spinner :md-diameter="20" v-if="loading" md-mode="indeterminate" />
        {{
        !value.parcialInputsMode ? "Confirmar entrada completa" : "Confirmar entradas parciales"
        }}
      </md-button>
    </template>

    <template v-else-if="!hasNoPhysicalEntries && !hasAllPhysicalEntries">
      <p
        v-show="!validRemainingQuantity"
        class="text-warning md-layout-item md-size-50 mr-auto"
      >Las cantidades de material no coinciden, favor de verificar</p>
      <md-button
        class="md-success"
        :disabled="!validRemainingQuantity"
        @click="sendData"
      >Registrar entrada</md-button>
    </template>
    <template v-else-if="(!hasNoPhysicalEntries && hasAllPhysicalEntries)">
      <md-button class="md-warning" @click="sendData">Cerrar orden</md-button>
    </template>
    <modal v-if="showCommentModal" @close="showCommentModal = false">
      <md-toolbar class="md-danger" dark slot="header">
        <h4 class="text-center">Confirmar entrada de material incorrecta.</h4>
      </md-toolbar>
      <form id="confirmation-form" @submit.prevent="submitConfirmation">
        <md-field>
          <label>Comentario:</label>
          <md-textarea v-model="reviComment" />
        </md-field>
      </form>

      <div slot="footer">
        <md-button
          class="md-sm md-round md-danger"
          type="submit"
          :disabled="
            !reviComment ||
            reviComment.length <= 4 ||
            !$can(
              'can_change_material_input',
              'IWarehouse',
              'iwarehousemovement'
            )
          "
          form="confirmation-form"
        >Confirmar</md-button>
        <md-button class="md-sm md-round" @click="cancelConfirmation">Cancelar</md-button>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "PurchaseOrderActions",

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    comment: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
    },
    validRemainingQuantity: {
      type: Boolean,
    },
    hasNoPhysicalEntries: {
      type: Boolean,
    },
    hasAllPhysicalEntries: {
      type: Boolean,
    },
    isTransfer: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showCommentModal: false,
      reviComment: "",
    };
  },

  methods: {
    cancelConfirmation() {
      this.showCommentModal = false;
    },
    // confirmValidation() {
    //   const { parcialInputsMode } = this.value;
    //   if (parcialInputsMode) {
    //     this.showCommentModal = true;
    //   } else {
    //     this.sendData();
    //   }
    // },
    sendData() {
      // const { reviComment: comment } = this;
      this.$emit("sendData", { comment: "" });
    },
    submitConfirmation() {
      this.showCommentModal = false;
      this.sendData();
    },
  },

  watch: {
    comment: {
      immediate: true,
      handler(value) {
        this.reviComment = value;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Purchases/InputFromPurchaseOrder/PurchaseOrderActions.vue